
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface ScheduleDialogErrorProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  error: Error;
}

export const ScheduleDialogError: React.FC<ScheduleDialogErrorProps> = ({ open, onOpenChange, error }) => {
  return (
    <Dialog open={open} onOpenChange={(openState) => !openState && onOpenChange(false)} modal>
      <DialogContent 
        className="bg-[#0F141C] border-[#223342] text-white max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Agendar Mentoria</DialogTitle>
        </DialogHeader>
        <div className="py-6 text-center">
          <p className="text-red-400">Erro ao carregar disponibilidade: {error.message}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
